import {Lock} from 'lucide-react';
import {createLucideIcon} from '../create-lucide-icon';

export const LockIcon = createLucideIcon(Lock, 'LockIcon');
